// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userReviewSlider_reviewSection__YOUwj {
  padding: 20px 16px;
  margin: 0 16px 20px;
  border-radius: 16px;
    border: 1px solid #FFFFFF33;
  /* background: var(--Darker-gradient-03, linear-gradient(109deg, #3D4865 0%, #16191F 100%)); */
  background: #3D4865;
  touch-action: pan-y;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.userReviewSlider_reviewHeader__tHX86 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.userReviewSlider_reviewProfile__2\\+sZJ {
  display: flex;
  align-items: center;
  gap: 12px;
}

.userReviewSlider_reviewAvatar__NK304 {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
}

.userReviewSlider_reviewAvatar__NK304 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}

.userReviewSlider_avatarVisible__w6\\+Nl {
  opacity: 1;
  visibility: visible;
  z-index: 1;
}

.userReviewSlider_avatarHidden__ZUOU9 {
  opacity: 0;
  visibility: hidden;
  z-index: 0;
  pointer-events: none;
}

.userReviewSlider_avatarPlaceholder__PF0IZ {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
}

.userReviewSlider_avatarPlaceholderImage__edcp\\+ {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.userReviewSlider_reviewUserInfo__3gQkT {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.userReviewSlider_reviewName__oFP20 {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  line-height: 17px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.userReviewSlider_reviewLocation__ILche {
  font-size: 12px;
  font-weight: 400;
  color: #959595;
  line-height: 15px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.userReviewSlider_reviewRating__sWTT1 {
  display: flex;
  align-items: center;
  gap: 4px;
}

.userReviewSlider_reviewText__IbDGl {
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  margin-bottom: 16px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.userReviewSlider_reviewPagination__8K1ld {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.userReviewSlider_paginationDot__tzJ4- {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #4F5568;
  cursor: pointer;
  transition: all 0.3s ease;
}

.userReviewSlider_paginationDotActive__z5Krv {
  background: #959595;
  width: 8px;
  height: 8px;
}

`, "",{"version":3,"sources":["webpack://./src/components/pwatv/UserReviewSlider/userReviewSlider.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;IACjB,2BAA2B;EAC7B,8FAA8F;EAC9F,mBAAmB;EACnB,mBAAmB;EACnB,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,+EAA+E;AACjF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;AACb","sourcesContent":[".reviewSection {\n  padding: 20px 16px;\n  margin: 0 16px 20px;\n  border-radius: 16px;\n    border: 1px solid #FFFFFF33;\n  /* background: var(--Darker-gradient-03, linear-gradient(109deg, #3D4865 0%, #16191F 100%)); */\n  background: #3D4865;\n  touch-action: pan-y;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.reviewHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.reviewProfile {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.reviewAvatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.reviewAvatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.avatarVisible {\n  opacity: 1;\n  visibility: visible;\n  z-index: 1;\n}\n\n.avatarHidden {\n  opacity: 0;\n  visibility: hidden;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.avatarPlaceholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.avatarPlaceholderImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.reviewUserInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.reviewName {\n  font-size: 14px;\n  font-weight: 500;\n  color: #ffffff;\n  line-height: 17px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.reviewLocation {\n  font-size: 12px;\n  font-weight: 400;\n  color: #959595;\n  line-height: 15px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.reviewRating {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.reviewText {\n  font-size: 14px;\n  font-weight: 400;\n  color: #ffffff;\n  line-height: 20px;\n  margin-bottom: 16px;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.reviewPagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.paginationDot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #4F5568;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.paginationDotActive {\n  background: #959595;\n  width: 8px;\n  height: 8px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reviewSection": `userReviewSlider_reviewSection__YOUwj`,
	"reviewHeader": `userReviewSlider_reviewHeader__tHX86`,
	"reviewProfile": `userReviewSlider_reviewProfile__2+sZJ`,
	"reviewAvatar": `userReviewSlider_reviewAvatar__NK304`,
	"avatarVisible": `userReviewSlider_avatarVisible__w6+Nl`,
	"avatarHidden": `userReviewSlider_avatarHidden__ZUOU9`,
	"avatarPlaceholder": `userReviewSlider_avatarPlaceholder__PF0IZ`,
	"avatarPlaceholderImage": `userReviewSlider_avatarPlaceholderImage__edcp+`,
	"reviewUserInfo": `userReviewSlider_reviewUserInfo__3gQkT`,
	"reviewName": `userReviewSlider_reviewName__oFP20`,
	"reviewLocation": `userReviewSlider_reviewLocation__ILche`,
	"reviewRating": `userReviewSlider_reviewRating__sWTT1`,
	"reviewText": `userReviewSlider_reviewText__IbDGl`,
	"reviewPagination": `userReviewSlider_reviewPagination__8K1ld`,
	"paginationDot": `userReviewSlider_paginationDot__tzJ4-`,
	"paginationDotActive": `userReviewSlider_paginationDotActive__z5Krv`
};
export default ___CSS_LOADER_EXPORT___;
